// extracted by mini-css-extract-plugin
export var photoInfoContainer = "styles-module__photoInfoContainer___Q_0Rw";
export var userAndCaption = "styles-module__userAndCaption___UA1pO";
export var userLink = "styles-module__userLink___CTpQL";
export var adminLink = "styles-module__adminLink___NKfom";
export var unhideLink = "styles-module__unhideLink___mot9g";
export var creditLinkContainer = "styles-module__creditLinkContainer___ZLLTy";
export var photoTimeDisplay = "styles-module__photoTimeDisplay___IuwH0";